import { render, staticRenderFns } from "./UserGroupCreate.vue?vue&type=template&id=5a30229e&"
import script from "./UserGroupCreate.vue?vue&type=script&lang=js&"
export * from "./UserGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports